import styled, { css } from 'styled-components'

import ButtonStyled from 'components/Editor/EditorElements/courseKit/DropdownMenuCourse/styled/ButtonStyled'

const desktopStyles = css`
  &:not(:focus):not(:active) {
    position: absolute;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    pointer-events: none;
    white-space: nowrap;
    width: 1px;
  }
`

const ZoomButtonStyled = styled(ButtonStyled)<{ $isDesktop: boolean }>`
  position: absolute;
  display: flex;
  width: 28px;
  height: 28px;
  right: 8px;
  bottom: 8px;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.6);
  object-position: 50% 50%;

  ${({ $isDesktop }) => $isDesktop && desktopStyles}
`
export default ZoomButtonStyled
